// MODIFIED: Destructure currentPage and setCurrentPage from props and pass to CreateTable
import EditIcon from "@mui/icons-material/Edit";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";

export function ApproverMaintenanceTable({ data, onEdit, currentPage, setCurrentPage }) {
  const headers = ["Maintenance Value", "Hierarchy Level Count", "Is Active?", "Actions"];
  const accessors = ["maintenanceValueName", "approverHierarchyCount", "isActive", "actions"];

  const actions = [
    {
      name: "Manage",
      icon: <EditIcon fontSize="small" />,
      className: "bg-blue-500 hover:bg-blue-600",
      function: (item) => onEdit(item),
      visible: true,
    }
  ];

  return (
    <CreateTable
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage} // // ADDED
      setCurrentPage={setCurrentPage} // // ADDED
      itemsPerPage={10}
      totalItems={data.length}
    />
  );
}